exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-5a343b32]{font-size:15px;text-align:justify}div[data-v-5a343b32]{color:#fff}", ""]);

// exports
